import { AccountServicePath } from "utils/constants";
import { buildFilterQueryString, buildQueryString } from "utils/helpers";

export const accountRequests = {
  getUsersInfoSearch: ({ id, personId, email } = {}) =>
    `${AccountServicePath}users/info/search${buildQueryString({ Id: id, PersonId: personId, Email: email })}`,
  getUsersInfoList: ({ ids, personIds } = {}) =>
    `${AccountServicePath}users/info/list${buildFilterQueryString({ Ids: ids, PersonIds: personIds })}`,
  getUserById: userId => `${AccountServicePath}users/${userId}`,
  getUserAddresses: userId => `${AccountServicePath}users/${userId}/addresses`,
  getSuperLoginByUserId: userId => `${AccountServicePath}security/users/${userId}/super-login`,
  changeUserEmail: userId => `${AccountServicePath}users/${userId}/email`,
  changeUserEmailInstant: userId => `${AccountServicePath}users/${userId}/email/instant`,
  updateUserPersonalData: userId => `${AccountServicePath}users/info/${userId}`,
  changeUserPassword: userId => `${AccountServicePath}users/${userId}/password`,

  updatePermissionRoles: permissionId => `${AccountServicePath}permissions/${permissionId}/roles`,

  getPermissionsSelect: () => `${AccountServicePath}permissions`,
  getRolesSelect: () => `${AccountServicePath}roles/select`,
  getUsersSelect: () => `${AccountServicePath}users/select`,
  getUsersByIdsSelect: ids => `${AccountServicePath}users/select${buildQueryString({ ids })}`,
  ldapLogin: () => `${AccountServicePath}security/ldap/login`,
  getProfiles: () => `${AccountServicePath}security/profiles`,
  postSwitchProfile: () => `${AccountServicePath}security/profiles/switch`,
  getAltchaChallenge: () => "/altcha/api/challenge",
};
